import { mapAppliedDiscounts } from './map-applied-discounts.js';

const getPrices = (orderLineItem, intl)=>{
    var ref, ref1, ref2, ref3;
    var _gross;
    const price = (_gross = orderLineItem.price.total.gross) !== null && _gross !== void 0 ? _gross : 0;
    var _subtotal;
    const originalPrice = (_subtotal = orderLineItem.price.total.subtotal) !== null && _subtotal !== void 0 ? _subtotal : 0;
    var _amount;
    const discountPrice = (_amount = orderLineItem.price.total.discount.amount) !== null && _amount !== void 0 ? _amount : 0;
    var _amount1;
    const tax = (_amount1 = (ref = orderLineItem.price) === null || ref === void 0 ? void 0 : ref.total.tax.amount) !== null && _amount1 !== void 0 ? _amount1 : 0;
    var ref4;
    const taxRate = (ref4 = (ref2 = (ref1 = orderLineItem.price) === null || ref1 === void 0 ? void 0 : ref1.unit.tax.portions[0]) === null || ref2 === void 0 ? void 0 : ref2.rate) !== null && ref4 !== void 0 ? ref4 : 0;
    var _gross1, _subtotal1, _amount2, ref5, _amount3;
    return {
        price,
        discountPrice,
        tax,
        taxRate,
        originalPrice,
        unitPrice: {
            price: (_gross1 = orderLineItem.price.unit.gross) !== null && _gross1 !== void 0 ? _gross1 : 0,
            originalPrice: (_subtotal1 = orderLineItem.price.unit.subtotal) !== null && _subtotal1 !== void 0 ? _subtotal1 : 0,
            tax: (_amount2 = orderLineItem.price.unit.tax.amount) !== null && _amount2 !== void 0 ? _amount2 : 0,
            taxRate: (ref5 = (ref3 = orderLineItem.price.unit.tax.portions[0]) === null || ref3 === void 0 ? void 0 : ref3.rate) !== null && ref5 !== void 0 ? ref5 : 0,
            discountPrice: (_amount3 = orderLineItem.price.unit.discount.amount) !== null && _amount3 !== void 0 ? _amount3 : 0,
            appliedDiscounts: mapAppliedDiscounts(orderLineItem.price.unit.discount.appliedDiscounts, intl)
        }
    };
};

export { getPrices };
//# sourceMappingURL=get-prices.js.map
